import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import moment from "moment";
import { Formik, FieldArray } from "formik";
import * as Yup from "yup";
import { Button, Card, Tab, Tabs } from "react-bootstrap";
import { RxCross1 } from "react-icons/rx";
import { FaPlus } from "react-icons/fa6";
// extractCoordinates
import { SweetAlert } from "../../../../helpers/helper";
import { get, post } from "../../../../components/api";
import useDistanceMatrix from "../../../../hooks/useDistanceMatrix";
import GoogleMapsLoader from "../../../../components/GoogleMapsLoader"
import AutocompleteInput from "../../../../components/AutocompleteInput";
import { ReactSelect } from "../../../../components/ReactSelect";
import AddIcon from "../../../../assets/images/tms/add.png";
import Loading from "../../../../components/Loading";
// import MapTollContainer from "../../../../components/MapTollContainer";
import ReusableSwitch from "../../../../components/ReusableSwitch";
import GoogleMapComponent from "../../../../components/MapComponent";

const validationSchema = Yup.object().shape({
  routeName: Yup.string().required("Route is required"),
  // vehicles: Yup.string().required("Vehicles is required"),
  // tags: Yup.string().required("Tags is required"),
  // vendor: Yup.string().required("vendor is required"),
  routePoints: Yup.array()
    .of(
      Yup.object().shape({
        // startPoint: Yup.string().required("Start Point is required"),
      })
    )
    .min(2, "You must select at least 2 route points"),
  routeExpense: Yup.array().of(
    Yup.object().shape({
      vehicleSize: Yup.string().required("vehicle size is required"),
    })
  ),
  routeBudget: Yup.array().of(
    Yup.object().shape({
      // budgetName: Yup.string().required("Budget name is required"),
    })
  ),
});

const tollTypeArr = [
  { _id: "2AxlesTruck", name: "Truck - 2 Axles" },
  { _id: "3AxlesTruck", name: "Truck - 3 Axles" },
  { _id: "4AxlesTruck", name: "Truck - 4 Axle" },
  { _id: "5AxlesTruck", name: "Truck - 5 Axle" },
  { _id: "6AxlesTruck", name: "Truck - 6 Axle" },
  { _id: "7AxlesTruck", name: "Truck - 7 Axle" },
];

const paymentTypeArr = [
  { _id: "Online", name: "Online" },
  { _id: "Cash", name: "Cash" },
];

const RouteAddPage = () => {
  // const hasFetched = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const fromData = location.state?.fromModule1Data;
  const [selectedTab, setSelectedTab] = useState("routePoints");
  const [isShowTolls, setIsShowTolls] = useState(false);
  const [locationsData, setLocationData] = useState([]);
  const [vehicleData, setVehicleData] = useState([]);
  const [tagsData, setTagsData] = useState([]);
  const [tyreSizeData, setTyreSizeData] = useState([]);
  const [vendorsData, setVendorsData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [routes, setRoutes] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [showToll, setShowToll] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [selectedRouteIndex, setSelectedRouteIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedVehicleSize, setSelectedVehicleSize] = useState("");
  const distances = useDistanceMatrix(locationsData);
  const [selectedTollVehicle, setselectedTollVehicle] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);

  const getVehicles = async () => {
    const vehiclesData = await get("/admin/vehicles-list");
    if (vehiclesData.status === 200) {
      const vehicleList = [];
      if (vehiclesData.data.length > 0) {
        vehiclesData.data.map((vehicle) => {
          vehicleList.push({
            name: vehicle.vehicleNo,
            _id: vehicle._id,
          });
        });
      }
      setVehicleData(vehicleList);
    } else {
      setVehicleData([]);
    }
  };

  const getTags = async () => {
    const tags = await post("/admin/tms/tags-list", {});
    if (tags.status === 200) {
      const tagList = [];
      if (tags.data.length > 0) {
        tags.data.map((tag) => {
          tagList.push({
            name: tag.name,
            _id: tag._id,
          });
        });
      }
      setTagsData(tagList);
    } else {
      setTagsData([]);
    }
  };

  const getTyreSize = async () => {
    const tyreSizes = await get("/admin/ltms/get-TyreSize");
    if (tyreSizes.status === 200) {
      const tyreList = [];
      if (tyreSizes.data.length > 0) {
        tyreSizes.data.map((tyre) => {
          tyreList.push({
            name: tyre.label,
            _id: tyre._id,
          });
        });
      }
      setTyreSizeData(tyreList);
    } else {
      setTyreSizeData([]);
    }
  };

  const getVendors = async () => {
    const vendors = await get("/admin/tms/vendors");
    if (vendors.status === 200) {
      setVendorsData(vendors.data);
    } else {
      setVendorsData([]);
    }
  };

  useEffect(() => {
    getVehicles();
    getTags();
    getTyreSize();
    getVendors();
  }, []);

  useEffect(() => {
    if (locationsData.length >= 2) {
      const updatedRoutePoints = locationsData.map((point) => ({
        lat: point.coordinates[0],
        lng: point.coordinates[1],
      }));
      setSelectedLocation(updatedRoutePoints);
    }
  }, [locationsData]);

  // useEffect(() => {
  //   const getTolls = async () => {
  //     const origin = {
  //       lat: locationsData[0].coordinates[0],
  //       lng: locationsData[0].coordinates[1],
  //     };
  //     const destination = {
  //       lat: locationsData[locationsData.length - 1].coordinates[0],
  //       lng: locationsData[locationsData.length - 1].coordinates[1],
  //     };
  //     const waypoints = locationsData
  //       .slice(1, locationsData.length - 1)
  //       .map((loc) => ({
  //         lat: loc[0],
  //         lng: loc[1],
  //       }));
  //     let obj = {
  //       from: origin,
  //       to: destination,
  //       vehicle: {
  //         type: "2AxlesTruck",
  //       },
  //       truck: {
  //         truckRestrictionPenalty: "soft",
  //       },
  //       departure_time: `${moment().utc()}`,
  //       mileage: 3.5,
  //     };
  //     if (Array.isArray(waypoints) && waypoints.length > 0) {
  //       obj.waypoints = waypoints;
  //     }
  //     try {
  //       const tripCalcApiRes = await post("/calculate-trip", obj);
  //       if (tripCalcApiRes.status === 200) {
  //         let routes = tripCalcApiRes.apiRes.routes;
  //         if (Array.isArray(routes) && routes.length > 0) {
  //           let updatedRoutes = routes.map((data) => {
  //             let { origin, destination, waypoints } = extractCoordinates(
  //               data.summary.url
  //             );
  //             data.summary.origin = origin;
  //             data.summary.destination = destination;
  //             data.summary.waypoints = waypoints;
  //             return data;
  //           });
  //           setRoutes(updatedRoutes);
  //           setShowToll(true);
  //           setSelectedRoute(updatedRoutes[0]);
  //           setIsLoading(false);
  //         } else {
  //           setRoutes([]);
  //           setSelectedRoute(null);
  //           setIsLoading(false);
  //           setShowToll(false);
  //         }
  //       } else {
  //         setIsLoading(false);
  //         setShowToll(false);
  //       }
  //     } catch (error) {
  //       SweetAlert(error.message, true);
  //     }
  //   };
  //   if (locationsData.length === 2 && !hasFetched.current) {
  //     console.log("calling...");
  //     hasFetched.current = true;
  //     getTolls();
  //   }
  // }, [locationsData]);

  const changeRoute = (route, index) => {
    setSelectedRoute(route);
    setSelectedRouteIndex(index);
  };

  const handleSwitchChange = (e) => {
    setIsShowTolls(e.target.checked);
  };

  const extractCityAndState = (place) => {
    const components = place?.address_components || [];
    const getComponent = (type) => {
      const comp = components.find((c) => c.types.includes(type));
      return comp ? comp.long_name : "";
    };
    const city =
      getComponent("locality") ||
      getComponent("administrative_area_level_2");
    const state = getComponent("administrative_area_level_1");
    return { city, state };
  };

  const extractIds = (arr) => arr.map((item) => item._id);
const mergeArrays = (target, source) => {
    const sourceMap = new Map(source.map((item) => [item.address, item]));
    return target.map((item) => {
      const sourceItem = sourceMap.get(item.address);
      return {
        ...item,
        ...(sourceItem ? { 
          ...sourceItem, 
          freightRate: item.freightRate, 
          freightFare: item.freightFare 
        } : {}),
      };
    });
  };

  return (
    <GoogleMapsLoader>
    <div className="margin-left-5 mt-3">
      <h5 className="route-title text-left">Add Route</h5>
      <div className="row pl-1 mt-3">
        <div className="col-12 col-md-5 col-lg-5 col-sm-12 p-0">
          <Card className="p-3 border-0 scrollable-div">
            <Formik
              initialValues={{
                routeName: "",
                vehicles: [],
                tags: [],
                vendor: "",
                routePoints: [
                  {
                    address: "",
                    city: "",
                    state: "",
                    freightRate: "",
                    freightFare: "",
                  },
                ],
                routeExpense: [
                  {
                    vehicleSize: "",
                    mileage: "",
                    tonnage: "",
                    tollType: "",
                    driverExpense: "",
                    driverExpenseLoadedtrip: "",
                    driverExpenseEmptytrip: "",
                    tollExpenses: "",
                    otherExpenses: "",
                    fuelCost: "",
                    fuelQuantity: "",
                  },
                ],
                routeBudget: [
                  {
                    budgetName: "",
                    transactionType: "",
                    amount: "",
                  },
                ],
              }}
              validationSchema={validationSchema}
              onSubmit={async (values) => {
                setIsLoading(true);
                const mergeRoutePoints = mergeArrays(
                  values.routePoints,
                  locationsData
                );
                const updatedRoutePoints = mergeRoutePoints.map(
                  (point, index) => ({
                    ...point,
                    distance: distances[index],
                  })
                );
                let newData = { ...values };
                newData.tags = extractIds(values.tags);
                newData.vehicles = extractIds(values.vehicles);
                newData.vendor = values.vendor._id;
                newData.routePoints = updatedRoutePoints;
                const response = await post("admin/tms/add/routes", newData);
                if (response?.status === 200) {
                  setIsLoading(false);
                  SweetAlert(response?.message, false);
                  if (fromData) {
                    navigate("/tms/add/trip", {
                      state: {
                        fromModule2: true,
                        formData: {
                          ...fromData,
                          route: {
                            _id: response.data._id,
                            name: response.data.routeName,
                          },
                        },
                        newSelected: {
                          _id: response.data._id,
                          name: response.data.routeName,
                        },
                      },
                    });
                  } else {
                    navigate("/tms/routes");
                  }
                } else if (response?.status === 201) {
                  setIsLoading(false);
                  SweetAlert(response?.message, true);
                }
              }}
            >
              {(formik) => {
                const { resetForm } = formik;
                return (
                  <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                      <div className="col-md-12 col-lg-12 col-xs-12">
                        <label className="route-label mb-2">Route Name</label>
                        <input
                          className="form-control input-field"
                          id="routeName"
                          name="routeName"
                          placeholder="Enter Route Name"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.routeName}
                        />
                        {formik.touched.routeName && formik.errors.routeName ? (
                          <div className="field-error ">
                            {formik.errors.routeName}
                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-12 col-lg-12 col-xs-12 mt-1">
                        <label className="route-label mb-2">Vehicles</label>
                        <ReactSelect
                          name="vehicles"
                          value={formik.values.vehicles}
                          options={vehicleData}
                          handleOnChange={(name, value) => {
                            formik.setFieldValue(name, value);
                          }}
                          isSearchable={true}
                          isLoading={false}
                          multiple={true}
                          noOptionsMessage="vehicles not availables."
                          placeholder="Select Vehicle"
                        />
                      </div>
                      <div className="col-md-12 col-lg-12 col-xs-12 mt-1">
                        <label className="route-label mb-2">Tags</label>
                        <ReactSelect
                          name="tags"
                          value={formik.values.tags}
                          options={tagsData}
                          handleOnChange={(name, value) => {
                            formik.setFieldValue(name, value);
                          }}
                          isSearchable={true}
                          isLoading={false}
                          multiple={true}
                          noOptionsMessage="Tags not availables."
                          placeholder="Select Tags"
                        />
                      </div>
                      <div className="col-md-12 col-lg-12 col-xs-12 mt-1">
                        <label className="route-label mb-2">Vendors</label>
                        <ReactSelect
                          name="vendor"
                          value={formik.values.vendor}
                          options={vendorsData}
                          handleOnChange={(name, value) => {
                            formik.setFieldValue(name, value);
                          }}
                          isSearchable={true}
                          isLoading={false}
                          noOptionsMessage="vendors not availables."
                          placeholder="Select Vendor"
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-12 col-lg-12 col-xs-12">
                        <Tabs
                          id="custom-tabs"
                          activeKey={selectedTab}
                          onSelect={(k) => setSelectedTab(k)}
                          className="route-tab-list"
                        >
                          {/* Route Points Tab */}
                          <Tab
                            eventKey="routePoints"
                            title="Route Points"
                            className="route-tab"
                          >
                            <div className="route-point">
                              <FieldArray name="routePoints">
                                {({ push, remove }) => (
                                  <div>
                                    {formik.values.routePoints.map(
                                      (_, index) => {
                                        return (
                                          <div
                                            key={index}
                                            className={`row dynamic-field mt-3 mb-3 ${
                                              index > 0 && "dynamic-border"
                                            }`}
                                          >
                                            <div className="col-md-12 col-lg-12 col-xs-12">
                                              <div className="d-flex justify-content-between align-items-center w-100">
                                                <div className="w-100 d-flex">
                                                  <label className="w-40 route-label mb-2">
                                                    Starting Point
                                                  </label>
                                                  {index > 0 && (
                                                    <div
                                                      className="remove-options mb-2"
                                                      onClick={() => {
                                                        remove(index);
                                                        setLocationData(
                                                          (prev) =>
                                                            prev.filter(
                                                              (_, i) =>
                                                                i !== index
                                                            )
                                                        );
                                                      }}
                                                    >
                                                      Route Point #{index}{" "}
                                                      <RxCross1 className="cursor-pointer" />
                                                    </div>
                                                  )}
                                                </div>
                                                <p className="route-label text-align-right">
                                                  Total Distance:{" "}
                                                  <span>
                                                    {distances.length === 0
                                                      ? 0
                                                      : distances.length > 2
                                                      ? distances[index]
                                                      : distances[0]}{" "}
                                                    km
                                                  </span>
                                                </p>
                                              </div>
                                              <AutocompleteInput
                                                key={`autocomplete-${index}`}
                                                className="form-control input-field"
                                                name={`routePoints[${index}].address`}
                                                value={
                                                  formik.values.routePoints[
                                                    index
                                                  ].address || ""
                                                }
                                                onChange={(e) => {
                                                  formik.setFieldValue(
                                                    `routePoints[${index}].address`,
                                                    e.target.value
                                                  );
                                                }}
                                                onPlaceSelected={(
                                                  place
                                                ) => {
                                                  if (!place.geometry) return;
                                                  const lat =
                                                    place.geometry.location.lat();
                                                  const lng =
                                                    place.geometry.location.lng();
                                                  const formattedAddress =
                                                    place.formatted_address;
                                                  const {city, state } = extractCityAndState(place);
                                                  formik.setFieldValue(
                                                    `routePoints[${index}].city`,
                                                    city
                                                  );
                                                  formik.setFieldValue(
                                                    `routePoints[${index}].state`,
                                                    state
                                                  );
                                                  formik.setFieldValue(
                                                    `routePoints[${index}].address`,
                                                    formattedAddress
                                                  );
                                                  // Store address + lat/lng in state
                                                  setLocationData(
                                                    (prevLocations) => {
                                                      const updatedLocations = [
                                                        ...prevLocations,
                                                      ];
                                                      updatedLocations[index] =
                                                        {
                                                          address:
                                                            formattedAddress,
                                                          coordinates: [
                                                            lat,
                                                            lng,
                                                          ],
                                                        };
                                                      return updatedLocations;
                                                    }
                                                  );
                                                }}
                                                placeholder="Enter Start Point"
                                              />
                                              {/* Displaying error for startPoint */}
                                              {formik.touched.routePoints?.[
                                                index
                                              ]?.address &&
                                                formik.errors.routePoints?.[
                                                  index
                                                ]?.address && (
                                                  <div className="field-error">
                                                    {
                                                      formik.errors.routePoints[
                                                        index
                                                      ].address
                                                    }
                                                  </div>
                                                )}
                                            </div>
                                            <div className="w-100 d-flex align-items-center mt-2">
                                              <div className="w-45">
                                                <label className="route-label mb-2">
                                                  Freight Rate
                                                </label>
                                                <input
                                                  className="form-control input-field"
                                                  name={`routePoints[${index}].freightRate`}
                                                  placeholder="Enter Freight Rate"
                                                  onChange={formik.handleChange}
                                                  onBlur={formik.handleBlur}
                                                  value={
                                                    formik.values.routePoints[
                                                      index
                                                    ].freightRate
                                                  }
                                                />
                                                {formik.touched.routePoints?.[
                                                  index
                                                ]?.freightRate &&
                                                  formik.errors.routePoints?.[
                                                    index
                                                  ]?.freightRate && (
                                                    <div className="field-error">
                                                      {
                                                        formik.errors
                                                          .routePoints[index]
                                                          .freightRate
                                                      }
                                                    </div>
                                                  )}
                                              </div>
                                              <div className="w-10 or-div">
                                                Or
                                              </div>
                                              <div className="w-45">
                                                <label className="route-label mb-2">
                                                  Freight Fare
                                                </label>
                                                <input
                                                  className="form-control input-field"
                                                  name={`routePoints[${index}].freightFare`}
                                                  placeholder="Enter Freight Fare"
                                                  onChange={formik.handleChange}
                                                  onBlur={formik.handleBlur}
                                                  value={
                                                    formik.values.routePoints[
                                                      index
                                                    ].freightFare
                                                  }
                                                />
                                                {formik.touched.routePoints?.[
                                                  index
                                                ]?.freightFare &&
                                                  formik.errors.routePoints?.[
                                                    index
                                                  ]?.freightFare && (
                                                    <div className="field-error">
                                                      {
                                                        formik.errors
                                                          .routePoints[index]
                                                          .freightFare
                                                      }
                                                    </div>
                                                  )}
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      }
                                    )}

                                    {formik.errors.routePoints &&
                                      typeof formik.errors.routePoints ===
                                        "string" && (
                                        <div className="field-error">
                                          {formik.errors.routePoints}
                                        </div>
                                      )}
                                    {formik.values.routePoints.length < 5 && (
                                      <div className="d-flex justify-content-end align-items-center mt-2">
                                        <hr className="hr" />
                                        <a
                                          href="#"
                                          className="d-flex justify-content-center align-items-center link-tag ml-2"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            push({
                                              address: "",
                                              freightRate: "",
                                              freightFare: "",
                                            });
                                          }}
                                        >
                                          <img
                                            src={AddIcon}
                                            width={"18px"}
                                            height={"18px"}
                                          />{" "}
                                          <span className="addBtnText">
                                            Add
                                          </span>
                                        </a>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </FieldArray>
                              {!isLoading ? (
                                showToll && (
                                  <div className="row">
                                    <div className="col-md-7 col-lg-7 col-xs-12">
                                      <ReactSelect
                                        name="tollype"
                                        value={selectedTollVehicle}
                                        options={tollTypeArr}
                                        handleOnChange={(name, value) => {
                                          setselectedTollVehicle(value);
                                        }}
                                        isSearchable={true}
                                        isLoading={false}
                                        noOptionsMessage="Tolltype not availables."
                                        placeholder="Select Tolltype"
                                      />
                                    </div>
                                    <div className="col-md-5 col-lg-5 col-xs-12">
                                      <ReusableSwitch
                                        id="custom-switch"
                                        label="Show Tolls on map"
                                        checked={isShowTolls}
                                        onChange={handleSwitchChange}
                                      />
                                    </div>
                                    <div className="col-md-12 col-lg-12 col-xs-12">
                                      <div className="d-flex justify-content-between align-items-center">
                                        <p className="mb-0 middle-title">
                                          Total Toll Charges{" "}
                                        </p>
                                        <p className="amount">
                                          {selectedRoute?.costs?.tag
                                            ? selectedRoute?.costs?.tag
                                            : 0}
                                        </p>
                                      </div>
                                    </div>
                                    {Array.isArray(routes) &&
                                      routes.length > 0 && (
                                        <div className="col-md-12 col-lg-12 col-xs-12">
                                          <div className="routeWrapper text-left">
                                            <p className="mb-2 custom-toll-text">
                                              {routes.length} Routes
                                              Found.please select route
                                            </p>
                                            <div>
                                              {routes.map((route, index) => (
                                                <Button
                                                  variant={
                                                    selectedRouteIndex === index
                                                      ? "btn-primary"
                                                      : "outline-primary"
                                                  }
                                                  key={index + 1}
                                                  onClick={() =>
                                                    changeRoute(route, index)
                                                  }
                                                  className={`${
                                                    selectedRouteIndex === index
                                                      ? "btn tms-submit-btn"
                                                      : "tms-cancel-btn"
                                                  } mr-10`}
                                                >
                                                  Route {index + 1}:{" "}
                                                  {route?.tolls?.length} tolls
                                                </Button>
                                              ))}
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                )
                              ) : (
                                <Loading />
                              )}
                            </div>
                          </Tab>
                          <Tab
                            eventKey="routeExpense"
                            title="Route Expense"
                            className="route-tab"
                          >
                            <FieldArray name="routeExpense">
                              {({ push, remove }) => (
                                <div>
                                  {formik.values.routeExpense.length === 0 && (
                                    <div className="d-flex justify-content-between align-items-center mt-2">
                                      <a
                                        href="#"
                                        className="d-flex justify-content-center align-items-center add-route-expense text-decoration-none"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          push({
                                            vehicleSize: "",
                                            mileage: "",
                                            tonnage: "",
                                            tollType: "",
                                            driverExpense: "",
                                            driverExpenseLoadedTrip: "",
                                            driverExpenseEmptyTrip: "",
                                            tollExpenses: "",
                                            otherExpenses: "",
                                            fuelCost: "",
                                            fuelQuantity: "",
                                          });
                                        }}
                                      >
                                        <FaPlus />
                                        <span>Add Route Expense</span>
                                      </a>
                                    </div>
                                  )}
                                  {formik.values.routeExpense.map(
                                    (_, index, array) => (
                                      <>
                                        {formik.values.routeExpense.length >
                                          0 && (
                                          <div
                                            key={index}
                                            className={`row dynamic-field ${
                                              index === 0 ? "mt-3" : ""
                                            }`}
                                          >
                                            <div className="col-md-12 col-lg-12 col-xs-12">
                                              <div className="d-flex justify-content-between align-items-center w-100">
                                                <div className="w-100 d-flex">
                                                  <label className="w-40 route-label mb-2">
                                                    Vehicle Size
                                                  </label>
                                                </div>
                                              </div>
                                              <ReactSelect
                                                name={`routeExpense[${index}].vehicles`}
                                                value={selectedVehicleSize}
                                                options={tyreSizeData} // Pass available vehicleSize
                                                handleOnChange={(
                                                  name,
                                                  value
                                                ) => {
                                                  formik.setFieldValue(
                                                    `routeExpense[${index}].vehicleSize`,
                                                    value._id
                                                  );
                                                  setSelectedVehicleSize(value);
                                                }}
                                                isSearchable={true}
                                                isLoading={false}
                                                noOptionsMessage="No vehicle size available"
                                                placeholder="Select vehicle size"
                                              />
                                              {formik.touched.routeExpense?.[
                                                index
                                              ]?.vehicleSize &&
                                                formik.errors.routeExpense?.[
                                                  index
                                                ]?.vehicleSize && (
                                                  <div className="field-error">
                                                    {
                                                      formik.errors
                                                        .routeExpense[index]
                                                        .vehicleSize
                                                    }
                                                  </div>
                                                )}
                                            </div>
                                            <div className="col-md-12 col-lg-12 col-xs-12 mt-2">
                                              <div className="d-flex justify-content-between align-items-center w-100">
                                                <div className="w-100 d-flex">
                                                  <label className="w-40 route-label mb-2">
                                                    Mileage
                                                  </label>
                                                </div>
                                              </div>
                                              <input
                                                className="form-control input-field"
                                                name={`routeExpense[${index}].mileage`}
                                                placeholder="Enter Mileage"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={
                                                  formik.values.routeExpense[
                                                    index
                                                  ].mileage
                                                }
                                              />
                                              {formik.touched.routeExpense?.[
                                                index
                                              ]?.mileage &&
                                                formik.errors.routeExpense?.[
                                                  index
                                                ]?.mileage && (
                                                  <div className="field-error">
                                                    {
                                                      formik.errors.routePoints[
                                                        index
                                                      ].mileage
                                                    }
                                                  </div>
                                                )}
                                            </div>
                                            <div className="col-md-12 col-lg-12 col-xs-12 mt-2">
                                              <div className="d-flex justify-content-between align-items-center w-100">
                                                <div className="w-100 d-flex">
                                                  <label className="w-40 route-label mb-2">
                                                    Tonnage (Weight)
                                                  </label>
                                                </div>
                                              </div>
                                              <input
                                                className="form-control input-field"
                                                name={`routeExpense[${index}].tonnage`}
                                                placeholder="Enter Tonnage(Weight)"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={
                                                  formik.values.routeExpense[
                                                    index
                                                  ].tonnage
                                                }
                                              />
                                              {formik.touched.routeExpense?.[
                                                index
                                              ]?.tonnage &&
                                                formik.errors.routeExpense?.[
                                                  index
                                                ]?.tonnage && (
                                                  <div className="field-error">
                                                    {
                                                      formik.errors.routePoints[
                                                        index
                                                      ].tonnage
                                                    }
                                                  </div>
                                                )}
                                            </div>
                                            <div className="col-md-12 col-lg-12 col-xs-12 mt-2">
                                              <div className="d-flex justify-content-between align-items-center w-100">
                                                <div className="w-100 d-flex">
                                                  <label className="w-40 route-label mb-2">
                                                    Toll Type
                                                  </label>
                                                </div>
                                              </div>
                                              <ReactSelect
                                                name={`routeExpense[${index}].tollType`}
                                                value={
                                                  formik.values.routeExpense[
                                                    index
                                                  ].tollType
                                                }
                                                options={tollTypeArr} // Pass available vehicles list
                                                handleOnChange={(name, value) =>
                                                  formik.setFieldValue(
                                                    `routeExpense[${index}].tollType`,
                                                    value
                                                  )
                                                }
                                                isSearchable={true}
                                                isLoading={false}
                                                noOptionsMessage="No toll type available"
                                                placeholder="Select Toll Type"
                                              />
                                              {formik.touched.routeExpense?.[
                                                index
                                              ]?.tollType &&
                                                formik.errors.routeExpense?.[
                                                  index
                                                ]?.tollType && (
                                                  <div className="field-error">
                                                    {
                                                      formik.errors
                                                        .routeExpense[index]
                                                        .tollType
                                                    }
                                                  </div>
                                                )}
                                            </div>
                                            <div className="col-md-12 col-lg-12 col-xs-12 mt-2">
                                              <div className="d-flex justify-content-between align-items-center w-100">
                                                <div className="w-100 d-flex">
                                                  <label className="w-40 route-label mb-2">
                                                    Driver Expense (INR)
                                                  </label>
                                                </div>
                                              </div>
                                              <input
                                                className="form-control input-field"
                                                name={`routeExpense[${index}].driverExpense`}
                                                placeholder="Enter Driver Expense"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={
                                                  formik.values.routeExpense[
                                                    index
                                                  ].driverExpense
                                                }
                                              />
                                              {formik.touched.routeExpense?.[
                                                index
                                              ]?.driverExpense &&
                                                formik.errors.routeExpense?.[
                                                  index
                                                ]?.driverExpense && (
                                                  <div className="field-error">
                                                    {
                                                      formik.errors.routePoints[
                                                        index
                                                      ].driverExpense
                                                    }
                                                  </div>
                                                )}
                                            </div>
                                            <div className="col-md-12 col-lg-12 col-xs-12 mt-2">
                                              <div className="d-flex justify-content-between align-items-center w-100">
                                                <div className="w-100 d-flex">
                                                  <label className="route-label mb-2">
                                                    Driver Expense Per Km (INR)
                                                    - Loaded Trip
                                                  </label>
                                                </div>
                                              </div>
                                              <input
                                                className="form-control input-field"
                                                name={`routeExpense[${index}].driverExpenseLoadedtrip`}
                                                placeholder="Enter Driver Expense(Loaded Trip)"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={
                                                  formik.values.routeExpense[
                                                    index
                                                  ].driverExpenseLoadedtrip
                                                }
                                              />
                                              {formik.touched.routeExpense?.[
                                                index
                                              ]?.driverExpenseLoadedtrip &&
                                                formik.errors.routeExpense?.[
                                                  index
                                                ]?.driverExpenseLoadedtrip && (
                                                  <div className="field-error">
                                                    {
                                                      formik.errors.routePoints[
                                                        index
                                                      ].driverExpenseLoadedtrip
                                                    }
                                                  </div>
                                                )}
                                            </div>
                                            <div className="col-md-12 col-lg-12 col-xs-12 mt-2">
                                              <div className="d-flex justify-content-between align-items-center w-100">
                                                <div className="w-100 d-flex">
                                                  <label className="route-label mb-2">
                                                    Driver Expense Per Km (INR)
                                                    - Empty Trip
                                                  </label>
                                                </div>
                                              </div>
                                              <input
                                                className="form-control input-field"
                                                name={`routeExpense[${index}].driverExpenseEmptytrip`}
                                                placeholder="Enter Driver Expense(Empty Trip)"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={
                                                  formik.values.routeExpense[
                                                    index
                                                  ].driverExpenseEmptytrip
                                                }
                                              />
                                              {formik.touched.routeExpense?.[
                                                index
                                              ]?.driverExpenseEmptytrip &&
                                                formik.errors.routeExpense?.[
                                                  index
                                                ]?.driverExpenseEmptytrip && (
                                                  <div className="field-error">
                                                    {
                                                      formik.errors.routePoints[
                                                        index
                                                      ].driverExpenseEmptytrip
                                                    }
                                                  </div>
                                                )}
                                            </div>
                                            <div className="col-md-12 col-lg-12 col-xs-12 mt-2">
                                              <div className="d-flex justify-content-between align-items-center w-100">
                                                <div className="w-100 d-flex">
                                                  <label className="w-40 route-label mb-2">
                                                    Toll Expenses (INR)
                                                  </label>
                                                </div>
                                              </div>
                                              <input
                                                className="form-control input-field"
                                                name={`routeExpense[${index}].tollExpenses`}
                                                placeholder="Enter Toll Expenses"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={
                                                  formik.values.routeExpense[
                                                    index
                                                  ].tollExpenses
                                                }
                                              />
                                              {formik.touched.routeExpense?.[
                                                index
                                              ]?.tollExpenses &&
                                                formik.errors.routeExpense?.[
                                                  index
                                                ]?.tollExpenses && (
                                                  <div className="field-error">
                                                    {
                                                      formik.errors.routePoints[
                                                        index
                                                      ].tollExpenses
                                                    }
                                                  </div>
                                                )}
                                            </div>
                                            <div className="col-md-12 col-lg-12 col-xs-12 mt-2">
                                              <div className="d-flex justify-content-between align-items-center w-100">
                                                <div className="w-100 d-flex">
                                                  <label className="route-label mb-2">
                                                    Other Expenses (INR)
                                                  </label>
                                                </div>
                                              </div>
                                              <input
                                                className="form-control input-field"
                                                name={`routeExpense[${index}].otherExpenses`}
                                                placeholder="Enter Other Expenses"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={
                                                  formik.values.routeExpense[
                                                    index
                                                  ].otherExpenses
                                                }
                                              />
                                              {formik.touched.routeExpense?.[
                                                index
                                              ]?.otherExpenses &&
                                                formik.errors.routeExpense?.[
                                                  index
                                                ]?.otherExpenses && (
                                                  <div className="field-error">
                                                    {
                                                      formik.errors.routePoints[
                                                        index
                                                      ].otherExpenses
                                                    }
                                                  </div>
                                                )}
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mt-1 mb-1">
                                              <p className="middle-title">
                                                Total Expense without Fuel
                                                (Loaded Trip)
                                              </p>
                                              <p className="amount">
                                                Rs.{" "}
                                                {formik.values.routeExpense.reduce(
                                                  (sum, point) =>
                                                    sum +
                                                    (point.driverExpense
                                                      ? parseInt(
                                                          point.driverExpense
                                                        )
                                                      : 0) +
                                                    (point.driverExpenseLoadedtrip
                                                      ? parseInt(
                                                          point.driverExpenseLoadedtrip
                                                        )
                                                      : 0) +
                                                    (point.driverExpenseEmptytrip
                                                      ? parseInt(
                                                          point.driverExpenseEmptytrip
                                                        )
                                                      : 0) +
                                                    (point.tollExpenses
                                                      ? parseInt(
                                                          point.tollExpenses
                                                        )
                                                      : 0) +
                                                    (point.otherExpenses
                                                      ? parseInt(
                                                          point.otherExpenses
                                                        )
                                                      : 0),
                                                  0
                                                )}
                                              </p>
                                            </div>
                                            <div className="col-md-12 col-lg-12 col-xs-12 mt-2">
                                              <div className="d-flex justify-content-between align-items-center w-100">
                                                <div className="w-100 d-flex">
                                                  <label className="route-label mb-2">
                                                    Fuel Cost (INR)
                                                  </label>
                                                </div>
                                              </div>
                                              <input
                                                className="form-control input-field"
                                                name={`routeExpense[${index}].fuelCost`}
                                                placeholder="Enter Fuel Cost"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={
                                                  formik.values.routeExpense[
                                                    index
                                                  ].fuelCost
                                                }
                                              />
                                              {formik.touched.routeExpense?.[
                                                index
                                              ]?.fuelCost &&
                                                formik.errors.routeExpense?.[
                                                  index
                                                ]?.fuelCost && (
                                                  <div className="field-error">
                                                    {
                                                      formik.errors.routePoints[
                                                        index
                                                      ].fuelCost
                                                    }
                                                  </div>
                                                )}
                                            </div>
                                            <div className="col-md-12 col-lg-12 col-xs-12 mt-2">
                                              <div className="d-flex justify-content-between align-items-center w-100">
                                                <div className="w-100 d-flex">
                                                  <label className="route-label mb-2">
                                                    Fuel Quantity(L)
                                                  </label>
                                                </div>
                                              </div>
                                              <input
                                                className="form-control input-field"
                                                name={`routeExpense[${index}].fuelQuantity`}
                                                placeholder="Enter Fuel Cost"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={
                                                  formik.values.routeExpense[
                                                    index
                                                  ].fuelQuantity
                                                }
                                              />
                                              {formik.touched.routeExpense?.[
                                                index
                                              ]?.fuelQuantity &&
                                                formik.errors.routeExpense?.[
                                                  index
                                                ]?.fuelQuantity && (
                                                  <div className="field-error">
                                                    {
                                                      formik.errors.routePoints[
                                                        index
                                                      ].fuelQuantity
                                                    }
                                                  </div>
                                                )}
                                            </div>
                                          </div>
                                        )}
                                        <div
                                          className={`d-flex align-items-center mt-2 ${
                                            index === array.length - 1 &&
                                            index < 4
                                              ? `justify-content-between`
                                              : `justify-content-end`
                                          }`}
                                        >
                                          {index === array.length - 1 &&
                                            index < 4 && (
                                              <a
                                                href="#"
                                                className="d-flex justify-content-center align-items-center add-route-expense text-decoration-none"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  push({ vehicleSize: "" });
                                                }}
                                              >
                                                <FaPlus />
                                                <span>Add Route Expense</span>
                                              </a>
                                            )}
                                          <a
                                            href="#"
                                            className="d-flex justify-content-center align-items-center add-route-expense text-decoration-none"
                                            onClick={(e) => {
                                              e.preventDefault();

                                              remove(index);
                                            }}
                                          >
                                            <span>
                                              Remove Route Expense #{index + 1}
                                            </span>
                                          </a>
                                        </div>
                                      </>
                                    )
                                  )}
                                </div>
                              )}
                            </FieldArray>
                          </Tab>
                          <Tab
                            eventKey="routeBudget"
                            title="Route Budget"
                            className="route-tab active-route-tab"
                          >
                            <FieldArray name="routeBudget">
                              {({ push, remove }) => (
                                <div>
                                  {formik.values.routeBudget.length === 0 && (
                                    <div className="d-flex justify-content-between align-items-center mt-2">
                                      <a
                                        href="#"
                                        className="d-flex justify-content-center align-items-center add-route-expense text-decoration-none"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          push({
                                            budgetName: "",
                                            transactionType: "",
                                            amount: "",
                                          });
                                        }}
                                      >
                                        <FaPlus />
                                        <span>Add Route Budget</span>
                                      </a>
                                    </div>
                                  )}
                                  {formik.values.routeBudget.map(
                                    (_, index, array) => (
                                      <>
                                        <div
                                          key={index}
                                          className={`row dynamic-field ${
                                            index === 0 ? "mt-3" : ""
                                          }`}
                                        >
                                          <div className="col-md-12 col-lg-12 col-xs-12 mt-2">
                                            <div className="d-flex justify-content-between align-items-center w-100">
                                              <div className="w-100 d-flex">
                                                <label className="w-40 route-label mb-2">
                                                  Budget Name
                                                </label>
                                              </div>
                                            </div>
                                            <input
                                              className="form-control input-field"
                                              name={`routeBudget[${index}].budgetName`}
                                              placeholder="Enter Budget Name"
                                              onChange={formik.handleChange}
                                              onBlur={formik.handleBlur}
                                              value={
                                                formik.values.routeBudget[index]
                                                  .budgetName
                                              }
                                            />
                                            {formik.touched.routeBudget?.[index]
                                              ?.budgetName &&
                                              formik.errors.routeBudget?.[index]
                                                ?.budgetName && (
                                                <div className="field-error">
                                                  {
                                                    formik.errors.routeBudget[
                                                      index
                                                    ].budgetName
                                                  }
                                                </div>
                                              )}
                                          </div>
                                          <div className="col-md-12 col-lg-12 col-xs-12 mt-2">
                                            <div className="d-flex justify-content-between align-items-center w-100">
                                              <div className="w-100 d-flex">
                                                <label className="w-40 route-label mb-2">
                                                  Transaction Type
                                                </label>
                                              </div>
                                            </div>
                                            <ReactSelect
                                              name={`routeBudget[${index}].transactionType`}
                                              value={paymentTypeArr.find(
                                                (data) =>
                                                  data?._id ==
                                                  formik.values.routeBudget[
                                                    index
                                                  ].transactionType
                                              )}
                                              options={paymentTypeArr}
                                              defaultValue={
                                                paymentTypeArr[0] || {}
                                              }
                                              handleOnChange={(name, value) =>
                                                formik.setFieldValue(
                                                  `routeBudget[${index}].transactionType`,
                                                  value._id
                                                )
                                              }
                                              isSearchable={false}
                                              isLoading={false}
                                              noOptionsMessage="No transaction type available"
                                              placeholder="Select Transaction Type"
                                              isClearable={false}
                                            />
                                            {formik.touched.routeBudget?.[index]
                                              ?.transactionType &&
                                              formik.errors.routeBudget?.[index]
                                                ?.transactionType && (
                                                <div className="field-error">
                                                  {
                                                    formik.errors.routeBudget[
                                                      index
                                                    ].transactionType
                                                  }
                                                </div>
                                              )}
                                          </div>
                                          <div className="col-md-12 col-lg-12 col-xs-12 mt-2">
                                            <div className="d-flex justify-content-between align-items-center w-100">
                                              <div className="w-100 d-flex">
                                                <label className="w-40 route-label mb-2">
                                                  Limit(amount)
                                                </label>
                                              </div>
                                            </div>
                                            <input
                                              className="form-control input-field"
                                              name={`routeBudget[${index}].amount`}
                                              placeholder="Enter Amount"
                                              onChange={formik.handleChange}
                                              onBlur={formik.handleBlur}
                                              value={
                                                formik.values.routeBudget[index]
                                                  .amount
                                              }
                                            />
                                            {formik.touched.routeBudget?.[index]
                                              ?.amount &&
                                              formik.errors.routeBudget?.[index]
                                                ?.amount && (
                                                <div className="field-error">
                                                  {
                                                    formik.errors.routeBudget[
                                                      index
                                                    ].amount
                                                  }
                                                </div>
                                              )}
                                          </div>
                                        </div>
                                        <div
                                          className={`d-flex align-items-center mt-2 ${
                                            index === array.length - 1 &&
                                            index < 4
                                              ? `justify-content-between`
                                              : `justify-content-end`
                                          }`}
                                        >
                                          {index === array.length - 1 &&
                                            index < 4 && (
                                              <a
                                                href="#"
                                                className="d-flex justify-content-center align-items-center add-route-expense text-decoration-none"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  push({
                                                    budgetName: "",
                                                    vehicleMaker: "",
                                                    amount: "",
                                                    transactionType: "",
                                                  });
                                                }}
                                              >
                                                <FaPlus />
                                                <span>Add Route Budget</span>
                                              </a>
                                            )}
                                          <a
                                            href="#"
                                            className="d-flex justify-content-center align-items-center add-route-expense text-decoration-none"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              remove(index);
                                            }}
                                          >
                                            <span>
                                              Remove Route Budget #{index + 1}
                                            </span>
                                          </a>
                                        </div>
                                      </>
                                    )
                                  )}
                                </div>
                              )}
                            </FieldArray>
                          </Tab>
                        </Tabs>
                      </div>
                    </div>
                    <Card.Footer className="d-flex justify-content-end align-items-end p-0">
                      <div className="mt-3">
                        <Button
                          variant="outline-primary tms-cancel-btn"
                          onClick={() => resetForm()}
                        >
                          Clear
                        </Button>
                        <Button
                          type="submit"
                          disabled={!formik.isValid || formik.isSubmitting}
                          className="btn btn-primary tms-submit-btn ml-2"
                        >
                          Create Route
                        </Button>
                      </div>
                    </Card.Footer>
                  </form>
                );
              }}
            </Formik>
          </Card>
        </div>
        <div className="col-12 col-md-7 col-lg-7 col-sm-12">
          <div style={{ borderRadius: "12px", overflow: "hidden" }}>
            {/* <MapTollContainer
              selectedRoute={selectedRoute}
              height="550px"
              isShowTolls={isShowTolls}
            /> */}
            <GoogleMapComponent locationsData={selectedLocation} />
          </div>
        </div>
      </div>
    </div>
    </GoogleMapsLoader>
  );
};

export default RouteAddPage;
